module.exports = __webpack_public_path__ + "static/media/laughing-emoji-svgrepo-com (1).896e2d50.svg";